module.exports = __webpack_public_path__ + "media/images/admin/magazines/icon_ring-0cbb6cc50d5f0770b38c360e1ba4c561.png";